import { render, staticRenderFns } from "./UploadProof.vue?vue&type=template&id=a6d568d4&scoped=true"
import script from "./UploadProof.vue?vue&type=script&lang=ts"
export * from "./UploadProof.vue?vue&type=script&lang=ts"
import style0 from "./UploadProof.vue?vue&type=style&index=0&id=a6d568d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d568d4",
  null
  
)

export default component.exports